import React, {useState} from 'react'
import {Form,Space, InputNumber, Switch, Button, Input, Upload, Image, Row, Col} from 'antd'
import { createEvents } from '../../api/events';
import { UploadOutlined, InboxOutlined ,MinusCircleOutlined} from '@ant-design/icons';
import storage from '../../shared/storage'
import Loader from '../../shared/loaderImg';
import {MdClose, MdDelete} from 'react-icons/md'
import styled from 'styled-components'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import {useHistory} from "react-router-dom";
import { useDispatch } from 'react-redux';
import ReactQuill from 'react-quill';
import {DatePicker} from 'antd'
import moment from 'moment'
import '../../../index.css'
import ModalForm from '../../shared/modal';
import { nanoid } from '@reduxjs/toolkit'
import EventTable from './eventTable'
import PressRelease from './PressImageTable'


const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const tailLayout = {
    wrapperCol: {
      offset: 4,
      span: 16,
    },
  };

  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 20, offset: 4 },
    },
  };


export default function AddEvents() {
    
    const history = useHistory();
    const [visibleEdit, setVisibleEdit] = useState(false)
    const dispatch = useDispatch();
    const [imgurl, setImgurl] = useState([])
    const [eventimage, setEventImage] = useState([])
    const [FeaturedImage,setFeaturedImage] = useState([])

    const [loading1, setLoading1] = useState(false)

    const [loading2,setLoading2] = useState(false)
    const [fileList, setFileList] = useState([])
    const [imagesfileList,setImageFileList] = useState([])
    const [event, setEvent] = useState("");
    const [addField,setAddField] = useState(false)
    const [button, setButton] = useState('save')
    const [eId,setId] = useState(0)
    const [uploadDone,setUploadDone] = useState(false)
    const [deletedEvents, setDeletedevents] = useState([])

 
      // console.log({FeaturedImage})
      //for featured images
      const [visibleFeatureImageEdit, setFeatureImageEdit] = useState(false)
      const [addPressReleaseField,setAddPressRelease] = useState(false)
      const [pId,setPid] = useState(0)
      const [PressButton, setPressButton] = useState('save')
      const [uploadPressReleaseDone, setUploadPressReleaseDone] = useState(false)
      const [deletedPressEvents, setDeletedPressevents] = useState([])



      const onAddPressRelease = (values) =>{
        if(button === 'save'){
          console.log("Its save button")
          //  setVisibleEdit(false)
          
          setAddPressRelease(false)
          setPid(null)
          form3.resetFields()
          
        }
        setUploadPressReleaseDone(true)
        // console.log({FeaturedImage})


      }

      const addPressReleaseImage = ()=>{
        setAddPressRelease(true)
        setPid(nanoid())

      }
      const removePressReleaseEvent = ()=>{
        setAddPressRelease(false)
        form3.resetFields()
      }

      const onPressReleaseCaption = (e,key)=>{
        FeaturedImage.map((item)=>{
          if(item.pId == key)
              return item.caption = e.target.value
          else
           return item
        })
      }

      const uploadPressReleaseFile = (info) =>{
         setLoading1(true)
         
         storage
         .ref("images/" + info.file.name)
         .put(info.file.originFileObj)
         .then(snapshot => {
           return snapshot.ref.getDownloadURL();
         })
         .then(url => {
          setFeaturedImage([...FeaturedImage, {image:url,caption:null,pId}])
           console.log({FeaturedImage})
           setLoading1(false)
         })
         .catch(error => {
           console.log({error});
         });

      }
       
      const handleClickPressDelete = (id) =>{
        const newPressRelease = FeaturedImage.filter(item =>{
          return item.pId !== id.pId
        })
        setDeletedPressevents([...FeaturedImage,id])
        setFeaturedImage(newPressRelease)
        setAddPressRelease(false)
      }

const handleClickDelete = (id) => {  
  const newPartArr = eventimage.filter(item => {
    console.log(id)
      return item.eId !== id.eId
  })      
  
  setDeletedevents([...deletedEvents, id])
  setEventImage(newPartArr)
  setAddField(false)
  // message.success('Part Deleted')
}

    const onCaption = (e,key)=>{
      console.log(e)
      console.log(key)
      FeaturedImage.map((item,i)=>{
        console.log(item)
        if(item.id == key)
          return item.caption = e.target.value
        else
        return item
      })

      // e.preventDefault()
      // // setFeaturedImage({...FeaturedImage, [e.target.name]: e.target.value });
      // FeaturedImage.caption = e.target.value
      // setFeaturedImage([{...FeaturedImage}])
    }




    const onEventCaption = (e,key)=>{
      console.log({eventimage})
      eventimage.map((item,i)=>{
       
        if(item.eId == key)
           return item.caption = e.target.value
          
        else
           return item
      })
    }
    const add = () => {
      setAddField(true)
     
      setId(nanoid())
    }
    const onFinish = (values) => {

    
      // console.log(values.date.format())
    const data = {

      title:values.title,
      image: imgurl[0],
      sub_title:values.sub_title , 
      description:event ,
      date:values.date,
      event_images:eventimage,
      featured_images:FeaturedImage,
       
     

    }
    console.log({data});
        dispatch(createEvents(data))
        history.goBack()
      
      };




      const handleChange = info => {
        console.log(info)
        setLoading1(true)
           
            storage
            .ref("images/" + info.file.name)
            .put(info.file.originFileObj)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL();
            })
            .then(url => {
              setImgurl([...imgurl, url])
              setLoading1(false)
            })
            .catch(error => {
              console.log({error});
            });
        
          };



          const remove = (e, url) =>{
    
            console.log({url})
            setImgurl(prev => prev.filter(item => console.log({item})))
            console.log(imgurl)
            
            }

            const removeEvent = ()=>{
              setAddField(false)
              form2.resetFields()
            }
            const removeeventImage = (e, url,key) =>{
    
              console.log({url})
              setEventImage(prev => prev.filter(item => item?.image !== url ))
              console.log({eventimage})
              
              }
              const removefeatureImage = (e, url) =>{
    
                setFeaturedImage(prev => prev.filter(item => item !== url))
                
                }
        
            const uploadButton = (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            );
            

            


          const uploadFile = (info)=>{
            console.log(info)
            
            setLoading1(true)
           
            storage
            .ref("images/" + info.file.name)
            .put(info.file.originFileObj)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL();
            })
            .then(url => {
              setEventImage([...eventimage, {image:url,caption:null,eId}])
              console.log({eventimage})
              setLoading1(false)
            })
            .catch(error => {
              console.log({error});
            });
          }
        //   const uploadFile = (value)=>{
        //     const id = nanoid()
        //     console.log({id})
        //     setId(id)
        //     setLoading2(true)
        //     console.log("The complete object is",value)
            
        //     let newfileList = [...value.fileList]
        //     newfileList = newfileList.map((item)=>{
        //         console.log(item)
           
               
        //         storage
        //         .ref("images/" + item.name)
        //         .put(item.originFileObj)
        //         .then(snapshot => {
        //             return snapshot.ref.getDownloadURL();
        //         })
            
        //         .then(url => {
        //             console.log(url);
        //             setEventImage([...eventimage, {image:url,caption:null,id:eId}])
        //             setLoading2(false)
        //             console.log("ImgUrl is",eventimage)                
        //         })
        //         .catch(error => {
        //             console.log("error in code")
        //             console.log({error});
        //         });
               
               
        //     })
            
            
        // }
      
    
      const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
      };
    
      const [form1] = Form.useForm();
      const [form2] = Form.useForm();
      const [form3] = Form.useForm();


      const onChange = (value)=> {
        console.log(`selected ${value}`)
    
      }

      const saveEventImage = (value)=>{
        console.log(value)
      }
    
      const saveImage = (values) =>{
        console.log(values)
      }
         
  const onAddPart = (values) => {
    setUploadDone(true)
    if(button === 'save'){
      console.log("Its save button")
      //  setVisibleEdit(false)
    
      setAddField(false)
       setId(null)
  form2.resetFields()
      
    }
     console.log({eventimage})
  }

     const modules = {
        toolbar: [
          [{ 'font': [] }],
          [{size: []}],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image','align','direction'],
          ['clean']
        ],
      }
    
      const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
      ]

        

    return (
      <FormWrap>

      <Form
      {...layout}
  
      name="basic"
      initialValues={{ remember: true }}
    
      onFinish={onFinish}
      form = {form1}
      onFinishFailed={onFinishFailed}
      className="mt-4"onAddPressRelease
    >


      <Form.Item
        label="Event Title"
        name="title">
        <Input className=" text-capitalize"  />
      </Form.Item>


      <Form.Item
            label={<p className="text-left text-indigo-800 m-0 ml-2 text-4xl ">Banner Image</p>}
            name="image"
            // rules={[{ required: true, message: 'required!' }]}
          >
                          <Row gutter={10}>
            <Col span={5}>
                {

                imgurl?.map((img, i)=>{

                  return <div className=" imglist " style={{height:"100px"}}>
                   
                  <Image    
                   preview={false}               
                   key={i}
                   style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
                   src={img}
                   placeholder={<Loader/> }              
                 />   

                  <h2 onClick={(e)=>remove(e, img)} className=" text-white  "> <MdDelete/></h2> 

                    </div>
                })
              }
              </Col>
              

                <Upload       
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleChange}
                        multiple={true}
                        style={{marginLeft:'0.5rem'}}
                        >
                        {imgurl?.length >= 1 ? null : uploadButton}
                        </Upload>
                </Row>

        </Form.Item>

        <Form.Item
        label=" Event Sub title"
        name="sub_title"
      >
        <Input className=" text-capitalize"  />

      </Form.Item>


      <Form.Item label = "Event Start Date"
                 name = "date">
            <DatePicker />
      </Form.Item>

       
       

      <Form.Item
        label="Description"
        name="description"
        // rules={[
        //   {
        //     required: true,
        //     message: 'required!',
        //   },
        // ]}
      >
        <>
         <ReactQuill 
         theme="snow" 
         value={event} 
         modules={modules}
         formats={formats}
         onChange={setEvent} />
         </>
      </Form.Item>  




     
        <Button style={{marginLeft:'350px',marginBottom:'25px'}}  onClick={() => setVisibleEdit(true)} >
                Add/Show Image Gallery Images
        </Button>

        <Button style={{marginLeft:'350px',marginBottom:'25px'}}  onClick={() => setFeatureImageEdit(true)} >
                Add/Show Press Release Images
        </Button>
 
 
     
      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>



    <ModalForm 
          isVisible={visibleEdit} 
          title="Add Event Gallery Images"
          footer={false}
          className=" pl-6"
          width="82%"
          cancel={()=>setVisibleEdit(!visibleEdit)}
          >
          <div>
            <div>
            {
               uploadDone ? <EventTable isLoading={false} data={eventimage} deleteEvent ={handleClickDelete}/> :""
            }
            </div>
            {!(addField) && <Button
              type="dashed"
              onClick={add}
              block
              icon={<PlusOutlined />}
            >
              Add Event Gallery
            </Button>}
            

            {
              addField && 
              <Form
            // cancel={cancel}
        form={form2}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onAddPart}
        onFinishFailed={onFinishFailed}
        >
            <Space
                  style={{ display: "flex", justifyContent :'space-around', marginBottom: 1 }}
                  align="baseline"
                >
                  <div className=' flex flex-col'>
        <Form.Item
        label={<p className="text-left text-indigo-800 m-0 ml-2 text-4xl ">Event Image</p>}
            name= "image"
            >   
              {/* <Button><Upload fileList = {fileList} onChange={ uploadFile}>Image</Upload></Button> */}
              
              
         
            {/* <Col span={5}>
                {

                eventimage?.map((img, i)=>{

                  return <div className="imglist" style={{height:"100px"}}>
                   
                  <Image    
                   preview={false}               
                   key={i}
                   style={{height:"100%", width:"100%", borderRadius: '0.25rem', display:'block', objectFit:'cover'}}
                   src={img?.image}
                   placeholder={<Loader/> }              
                 />   

                  <h2 onClick={(e)=>removeeventImage(e,img?.image,eId)} className=" text-black  "> <MdDelete/></h2> 

                    </div>
                })
              }
              </Col> */}
              

                <Button><Upload fileList = {fileList} onChange={ uploadFile}>Upload Event Image</Upload></Button>

                
                </Form.Item>
                </div>
 
              <Form.Item
                    name= "caption"
                    rules={[{ required: true, message: 'required!'}]}>
                   <Input onChange={(e)=>onEventCaption(e,eId)} placeholder="Caption"  style={{ width: '180px' }}/>
              </Form.Item>
             <div>
                  {  <MinusCircleOutlined  onClick={removeEvent}/>}
                </div>
                </Space>
              <Form.Item className="text-right">
                        <Button type="primary" id='draftbtn' className='w-36 mx-6' htmlType="submit">
                              {button === 'save' ? 'Save' : 'Update' }
                        </Button>
              </Form.Item>
              
        </Form>
               
              
 
               
            }
            {!(addField) &&  <div className='text-right mt-2'> 
{/* <Button id='orthobtn' className='w-36 mx-2 rounded'onClick={()=>setVisibleEdit(false)} >Cancel</Button> */}
<Button type="primary" id='draftbtn' className='w-36 mx-6' onClick={()=>setVisibleEdit(false)}>Submit</Button>
</div>
}
          </div>
             
        </ModalForm> 



        <ModalForm 
        isVisible={visibleFeatureImageEdit}
        title="Add Press Release Images"
        footer={false}
          className=" pl-6"
          width="82%"
          cancel={()=>setFeatureImageEdit(!visibleFeatureImageEdit)}
          >
            <div>
            <div>
            {
               uploadPressReleaseDone ? <PressRelease isLoading={false} data={FeaturedImage} deleteEvent ={handleClickPressDelete}/> :""
            }
            </div>
            {!(addPressReleaseField) && <Button
              type="dashed"
              onClick={addPressReleaseImage}
              block
              icon={<PlusOutlined />}
            >
              Add Press Release Images
            </Button>}

            {
              addPressReleaseField &&
               <Form form = {form3}
               name="basic"
                initialValues={{ remember: true }}
                onFinish={onAddPressRelease}
                onFinishFailed={onFinishFailed}>

                <Space
                  style={{ display: "flex", justifyContent :'space-around', marginBottom: 1 }}
                  align="baseline"
                >
                  <div className=' flex flex-col'>
              <Form.Item
                  label={<p className="text-left text-indigo-800 m-0 ml-2 text-4xl ">Event Image</p>}
                  name= "image"
                  >   
                <Button><Upload fileList = {fileList} onChange={ uploadPressReleaseFile}>Upload Event Image</Upload></Button>

                  </Form.Item>
                  </div>
                  <Form.Item
                    name= "caption"
                    rules={[{ required: true, message: 'required!'}]}>
                   <Input onChange={(e)=>onPressReleaseCaption(e,pId)} placeholder="Caption"  style={{ width: '180px' }}/>
              </Form.Item>
              <div>
                  {  <MinusCircleOutlined  onClick={removePressReleaseEvent}/>}
                </div>
                  </Space>
                  <Form.Item className="text-right">
                        <Button type="primary" id='draftbtn' className='w-36 mx-6' htmlType="submit">
                              {PressButton === 'save' ? 'Save' : 'Update' }
                        </Button>
              </Form.Item>

               </Form>
            }


{!(addPressReleaseField) &&  <div className='text-right mt-2'> 
{/* <Button id='orthobtn' className='w-36 mx-2 rounded'onClick={()=>setVisibleEdit(false)} >Cancel</Button> */}
<Button type="primary" id='draftbtn' className='w-36 mx-6' onClick={()=>setFeatureImageEdit(false)}>Submit</Button>
</div>
}

            </div>
          
        </ModalForm>
   </FormWrap>
    )
}



const FormWrap = styled.div`
position: relative;

.imglist {
overflow: hidden;
background-color: #f1f1f1;
text-align: center;


h2 { 
  
opacity : 0;
display:none;
position: absolute;
margin: 0;
bottom: 1%;
background-color: rgba(0,0,0,0.5);
cursor: pointer;
transition: 0.1s;

&:hover {

font-size: 1.5rem;
}

}

&:hover h2 {

opacity : 1;
display:block
}
}

`